import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MapActionsService } from "src/services/map/map-actions.service";
import { NavigationSettingsComponent } from "./navigation-settings/navigation-settings.component";
import { RightSidebarService } from "src/services/right-sidebar.service";

@Component({
    selector: "map-navigation-tools",
    imports: [CommonModule, ReactiveFormsModule, NavigationSettingsComponent],
    templateUrl: "./map-navigation-tools.component.html",
    styleUrl: "./map-navigation-tools.component.scss",
})
export class MapNavigationToolsComponent {
    rightSidebarVisible = inject(RightSidebarService).isOpen;

    constructor(private mapActionsService: MapActionsService) {}

    centerMapOnLocation = () => {
        this.mapActionsService.tryToSetUserLocation();
    };

    zoomOut(): void {
        this.mapActionsService.zoomOut();
    }

    zoomIn(): void {
        this.mapActionsService.zoomIn();
    }

    centerMapOnEstateLocation(): void {
        this.mapActionsService.centerMapOnEstateLocation();
    }
}
